<template>
    <b-card shadow type="secondary" title="Category">
        <b-card-body>
            <b-form @submit.stop.prevent="onSubmit">
                <b-form-group
                    id="name-group"
                    label="Name*"
                    label-for="input-name"
                >
                    <!-- disable editability if the user can view but not update -->
                    <b-form-input
                        type="text"
                        id="input-name"
                        v-model="model.name"
                        required
                        placeholder="Enter Name"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="is_default-group"
                    label="Default*"
                    label-for="input-is_default"
                >
                    <b-form-checkbox
                        id="input-is_default"
                        v-model="model.is_default"
                        name="input-is_default"
                        :value="1"
                        :unchecked-value="0"
                    >
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group
                    id="description-group"
                    label="Description"
                    label-for="input-description"
                >
                    <!-- disable editability if the user can view but not update -->
                    <b-form-input
                        type="text"
                        id="input-description"
                        v-model="model.description"
                        placeholder="Enter Description"
                        trim
                    ></b-form-input>
                </b-form-group>
                <b-button-group size="sm">
                    <b-button
                        variant="secondary"
                        :disabled="loading ? true : false"
                        @click="cancel()"
                        >{{ cancelLabel }}</b-button
                    >
                    <!-- render the submit button only if the user can update or create -->
                    <b-button
                        type="submit"
                        variant="primary"
                        :disabled="loading ? true : false"
                        v-if="hasPermissionUpdate || hasPermissionCreate"
                        >{{ submitLabel }}</b-button
                    >
                    <b-button
                        v-show="hasPermissionDelete"
                        @click="deleteItem()"
                        class="mr-2"
                        variant="warning"
                        v-if="!!this.model.id"
                    >
                        Delete Item
                    </b-button>
                </b-button-group>
            </b-form>
        </b-card-body>
    </b-card>
</template>
<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'requestCategories-ViewItem',
    mixins: [permissionsMixins],
    data() {
        return {
            model: {
                id: 0,
                name: null,
                is_default: false,
            },
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */
        canCreate() {
            console.log(this.user_permissions)
            return !this.model.id
        },
        /**
         * True if the user has permission to view but not update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canView() {
            return !!this.model.id
        },
        /**
         * True if the user has permission to update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canUpdate() {
            return !!this.model.id
        },
        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
        cancelLabel() {
            if (this.canView) {
                return 'Back'
            } else {
                return 'Cancel'
            }
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = this.item
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }
            if (!model.description) model.description = '-'
            console.log('model', model)
            const action = model.id ? 'update' : 'create'
            const path = `requestCategory/${action}`
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            this.$emit(
                                'success',
                                `${
                                    action.charAt(0).toUpperCase() +
                                    action.slice(1)
                                }d`
                            )
                        })
                        .catch(error => {
                            console.log('error', error)
                            this.$emit('error', error, model.name)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'requestCategory/delete'

            // Generate and display confirmation prompt
            const title = 'Delete Request Category?'
            const message = `Are you sure you want to delete ${model.name}?`
            const errorMsg = 'Unable to delete Request Category!'

            this.$emit(
                'delete-item',
                message,
                title,
                model.id,
                () => {
                    this.$emit('success', 'Deleted')
                },
                path,
                errorMsg
            )
        },
    },
}
</script>
<style></style>
